<template>
  <div class="download-page">
    <header class="download-header">
      <div class="container download-header__inner">
        <router-link to="/" class="download-header__logo">
          <span class="download-header__logo-go">Go</span> Trust
        </router-link>
      </div>
    </header>

    <main class="download-main">
      <div class="container download-main__inner">
        <div class="download-content">
          <h1 class="download-content__title">
            扫码下载 Go Trust，精准匹配你的考学之路
          </h1>

          <div class="download-cards">
            <div class="download-card">
              <span class="download-card__badge download-card__badge--android">ANDROID</span>
              <div class="download-card__qr download-card__qr--desktop">
                <div class="download-card__qr-placeholder" />
                <p class="download-card__qr-label">二维码占位</p>
              </div>
              <button class="download-card__btn download-card__btn--android">
                下载 Android 版
              </button>
            </div>

            <div class="download-card">
              <span class="download-card__badge download-card__badge--ios">iOS</span>
              <div class="download-card__qr download-card__qr--desktop">
                <div class="download-card__qr-placeholder" />
                <p class="download-card__qr-label">二维码占位</p>
              </div>
              <button class="download-card__btn download-card__btn--ios">
                在 App Store 下载
              </button>
            </div>
          </div>
        </div>

        <div class="download-preview">
          <PhoneMockup />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhoneMockup from '../components/PhoneMockup.vue'

export default {
  name: 'DownloadPage',
  components: {
    PhoneMockup,
  },
}
</script>

<style scoped>
.download-page {
  min-height: 100vh;
  background: #f5f5f3;
  display: flex;
  flex-direction: column;
}

.download-header {
  background: var(--color-primary);
  height: var(--header-height);
}

.download-header__inner {
  display: flex;
  align-items: center;
  height: 100%;
}

.download-header__logo {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-white);
}

.download-header__logo-go {
  position: relative;
}

.download-header__logo-go::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 3px;
  background: var(--color-accent);
  border-radius: 2px;
}

.download-main {
  flex: 1;
  padding: 32px 0 48px;
}

.download-main__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.download-content {
  width: 100%;
  text-align: center;
}

.download-content__title {
  font-size: 22px;
  font-weight: 800;
  color: #3d2e1f;
  line-height: 1.5;
  margin-bottom: 28px;
}

.download-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  margin: 0 auto;
}

.download-card {
  background: var(--color-white);
  border-radius: var(--radius-xl);
  padding: 24px 20px 20px;
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.download-card__badge {
  position: absolute;
  top: 16px;
  left: 16px;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  letter-spacing: 0.5px;
}

.download-card__badge--android {
  background: #e8f5e9;
  color: #2e7d32;
}

.download-card__badge--ios {
  background: #fff3e0;
  color: #e65100;
}

.download-card__qr--desktop {
  display: none;
}

.download-card__qr-placeholder {
  width: 140px;
  height: 140px;
  background: #ececec;
  border-radius: 8px;
  margin: 24px auto 8px;
}

.download-card__qr-label {
  font-size: 12px;
  color: var(--color-text-light);
  text-align: center;
  margin-bottom: 16px;
}

.download-card__btn {
  width: 100%;
  padding: 14px;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  color: var(--color-white);
  transition: opacity 0.2s, transform 0.15s;
}

.download-card__btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.download-card__btn--android {
  background: var(--color-primary);
}

.download-card__btn--ios {
  background: #4a3728;
}

.download-preview {
  width: 100%;
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) {
  .download-main {
    padding: 56px 0 64px;
  }

  .download-main__inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
  }

  .download-content {
    flex: 1;
    text-align: left;
    max-width: 520px;
  }

  .download-content__title {
    font-size: 32px;
    margin-bottom: 40px;
  }

  .download-cards {
    flex-direction: row;
    gap: 20px;
    max-width: none;
    margin: 0;
  }

  .download-card {
    flex: 1;
    padding: 28px 24px 24px;
    min-width: 200px;
  }

  .download-card__qr--desktop {
    display: block;
    width: 100%;
  }

  .download-card__qr-placeholder {
    width: 160px;
    height: 160px;
  }

  .download-preview {
    flex-shrink: 0;
  }
}

@media (min-width: 1024px) {
  .download-content__title {
    font-size: 36px;
  }

  .download-card__qr-placeholder {
    width: 180px;
    height: 180px;
  }
}
</style>
